/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'zsd-tinymce',
    templateUrl: './tinymce.component.html',
    styleUrls: ['./tinymce.component.scss'],


})
export class TinymceComponent implements OnInit {

    @Input() required = false;
    @Input() requiredError = '';
    @Input('tinymceData') tinymceData = '';
    @Input('controlName') public controlName = 'tinyMce';
    @Input('parentForm') public parentForm: FormGroup;
    @Input('placeholder') public placeholder: string;
    @Input() public showContextMenu: boolean;
    curLang: string;
    curLangUrl: string;
    partialUrl = '/servicedesk/assets/langs/';
    langDefault: boolean;

    tinymceForm: FormGroup;

    constructor(public formBuilder: FormBuilder) {

    }

    ngOnInit() {
        if (this.showContextMenu === undefined) {
            this.showContextMenu = false;
        }
        this.tinymceForm = this.formBuilder.group({
            tinymce: this.formBuilder.control('')
        });
        this.tinymceForm.get('tinymce').setValue(this.tinymceData);
        if (this.required) {
            this.tinymceForm.get('tinymce').setValidators([Validators.required]);
        }
        this.tinymceForm.updateValueAndValidity();
        if (this.parentForm) {
            this.parentForm.addControl(this.controlName, this.tinymceForm);
        }


        this.curLang = navigator.language.substring(0, 2);
        if (this.curLang === 'fr' || this.curLang === 'pl' || this.curLang === 'it' || this.curLang === 'de'
            || this.curLang === 'es') {
            this.langDefault = false;
            if (this.curLang === 'fr') {
                this.curLang = this.curLang + '_FR';

            }
            this.curLangUrl = this.partialUrl + this.curLang + '.js';
        } else {
            this.langDefault = true;
        }
    }
}
